module.exports = __webpack_public_path__ + "img/calendar-icon-gray.e5188e4d.svg";